import { useParams } from 'react-router';

import type { RoutePath } from '#/routing/classes/RoutePath';
import type {
  RoutePathOptionalParams,
  RoutePathRequiredParams,
} from '#/routing/classes/types/RouteParams';

export function useRouteParams<
  T extends RoutePath<string, string, string, string>,
>(_routePath: T) {
  return useParams() as Record<RoutePathRequiredParams<T['fullPath']>, string> &
    Partial<Record<RoutePathOptionalParams<T['fullPath']>, string>>;
}
